import React, { useContext } from "react";
import { NavMenu } from 'tea-component';
import { SYSTEM_THEME_KEY, SYSTEM_THEME_DARK, SYSTEM_THEME_DARK_CLASS, SYSTEM_THEME_LIGHT } from '@home/_config/config';
import './index.scss';
import { ThemeContext } from '@/pages/home/wrappers/common';
import { buriedBtnPoint } from "@home/utils/buriedPoint";
export default () => {
  const ThemeConsumer = ThemeContext.Consumer; // 订阅消费者
  const { themeValue, setThemeValue } = useContext(ThemeContext);
  const handleClickTheme = () => {
    let newTheme = '';
    if (themeValue === SYSTEM_THEME_DARK) {
      newTheme = SYSTEM_THEME_LIGHT;
      document.body.classList.remove(SYSTEM_THEME_DARK_CLASS);
    } else {
      newTheme = SYSTEM_THEME_DARK;
      document.body.classList.add(SYSTEM_THEME_DARK_CLASS);
    }
    localStorage.setItem(SYSTEM_THEME_KEY, newTheme);
    (window as any)?.aegis?.setConfig({
      ext3: newTheme,
    });
    (window as any)?.aegis?.reportEvent({
      name: '切换主题按钮点击', // 必填
      ext1: newTheme
    });
    
    buriedBtnPoint({
      buttonId: '100101003',
      extInfo: JSON.stringify({
        theme: newTheme
      }),
      pageId: '100101',
      typeId: 'homePage_pc_v2'
    });

    setThemeValue(newTheme);
  };

  return <NavMenu.Item>
    <ThemeConsumer>
      {(themeContextValue) => {
        const { themeValue } = themeContextValue;
        return <div
          onClick={handleClickTheme}
          className="dbh-old-version-wrap"
        >
          {themeValue}
        </div>;
      }}
    </ThemeConsumer>
  </NavMenu.Item>;
};
